import AbstractController from '../../../services/abstractController';
import AuthService from '../../../services/authService';

export default class LogoutController extends AbstractController {
  private authService = new AuthService();


  init() {
    super.init();
    this.authService.remove();
    window.location.href = '/public';
  }
}
